import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { name: String }

  verify() {
    const matches = this.inputTarget.value.trim() === this.nameValue
    this.submitTarget.disabled = !matches
    this.submitTarget.classList.toggle("opacity-50", !matches)
    this.submitTarget.classList.toggle("cursor-not-allowed", !matches)
  }
}
